import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  TextInput,
  DateInput,
  Filter,
} from "react-admin";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { downloadCSV } from "react-admin";
import moment from "moment";

const CaseSensitiveFilter = (props) => {
  return (
    <TextInput
      source="mentorName"
      alwaysOn
      {...props}
      onChange={(props) => {
        return {};
      }}
    />
  );
};

const AppointmentFilter = (props) => (
  <Filter {...props}>
    <DateInput source="appointmentDate" label="Search by Date" />
    <CaseSensitiveFilter label="Search Mentor Name" source="mentorName@case" />
  </Filter>
);

const exporter = (records) => {
  const AppointmentExport = records.map((record) => {
    const menteeArray = [];
    const ZoomString = JSON.parse(record.zoomMeeting);
    record.mentees.map((mentee) => menteeArray.push(mentee.name));
    const array = [];
    array.push(record.mentorName);
    array.push(moment(record.appointmentDate).format("L"));
    array.push(record.appointmentTime);
    array.push(record.duration);
    array.push(ZoomString.id);
    array.push(menteeArray);
    return array;
  });
  const csv = convertToCSV({
    fields: [
      "Mentor Name",
      "Appointment Date",
      "Appointment Time",
      "Duration",
      "Zoom Id",
      "Mentees Name",
    ],
    data: AppointmentExport,
  });
  downloadCSV(csv, "Appointment");
};
const ZoomComponent = (props) => {
  const ZoomString = props.record.hasOwnProperty("zoomMeeting")
    ? JSON.parse(props.record.zoomMeeting)
    : {};
  return (
    <div>
      <span>{ZoomString.hasOwnProperty("id") ? ZoomString.id : null}</span>
    </div>
  );
};

const MenteeComponent = (props) => {
  return (
    <div>
      {props.record.mentees.length > 0
        ? props.record.mentees.map((mentee) => (
            <div>
              <span>
                <b>{mentee.name + ","}</b>
              </span>
              &nbsp;
            </div>
          ))
        : ""}
    </div>
  );
};
const AppointmentList = (props) => (
  <List
    {...props}
    title="Appointment"
    exporter={exporter}
    bulkActionButtons={false}
    filters={<AppointmentFilter />}
  >
    <Datagrid>
      {/* <MentorList props={props} label="Mentor" /> */}
      <TextField label="Mentor Name" source="mentorName" />
      <ZoomComponent props={props} label="Zoom Id" />
      <DateField label="Appointment Date" source="appointmentDate" />
      <TextField label="Appointment Time" source="appointmentTime" />
      <TextField label="Payment Status" source="Status" />

      <MenteeComponent props={props} label="Mentee" />
    </Datagrid>
  </List>
);

export default AppointmentList;
